var map = {
	"./img1.png": 8852,
	"./img2.png": 2853,
	"./img3.png": 2770,
	"./img4.png": 9161,
	"./img5.png": 5890,
	"./img6.png": 3050,
	"./img7.png": 6209,
	"./img8.png": 5010
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1560;